var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vb-checkbox',{attrs:{"vb_options":{
    text: 'Solo voli diretti',
    value:
      _vm.max_number_of_connections === '0' || _vm.max_number_of_connections === 0,
    checked:
      _vm.max_number_of_connections === '0' || _vm.max_number_of_connections === 0,
    type: 'light',
    switch: _vm.is_switch,
  }},on:{"change":_vm.handle_change}})
}
var staticRenderFns = []

export { render, staticRenderFns }